
import { defineComponent } from 'vue';
import useLike from '@hooks/useLike';
import LikeBtn from './LikeBtn.vue';

export default defineComponent({
  name: 'LikeBtnWrap',
  props: {
    initId: {
      type: String,
      require: true,
    },
    initTotalNum: {
      type: Number,
      default: 0,
    },
    initIsLike: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: any) {
    const {
      linkTotalNum,
      isLike,
      isShowAnimate,
      showLikeBtn,
      updateLikeDataCustomer,
      like,
      cancelLike,
    } = useLike('playData');

    updateLikeDataCustomer(props.initId, props.initTotalNum, props.initIsLike);

    return {
      showLikeBtn,
      linkTotalNum,
      isLike,
      isShowAnimate,
      like,
      cancelLike,
    };
  },
  components: { LikeBtn },
});
